<template>
	<v-row>
		<v-col>
			<ui-box
					v-if="shouldShowSection('prize_setup') && !(shouldShowSection('basic') || shouldShowSection('advanced'))">
				<h5>Prizes in this Pass</h5>
				<span class="grey--text text--darken-1 text-body-2">
				</span>

				<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

				<v-row>
					<v-col cols="9">
						<v-select
								v-model="allPrizesSelection"
								class="rounded-lg"
								:items="allPrizesNotSelected"
								label="Add Prizes for this Pass"
								item-text="name"
								item-value="id"
								multiple
								chips
								outlined
								scroll-y
						></v-select>
					</v-col>
					<v-col cols="3">
						<v-btn
								class="mb-6 ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								@click="addPrizeToSelectedPrizes"
						>
							Add
						</v-btn>
					</v-col>
				</v-row>


				<v-row>
					<v-col>
						<ui-box>
							<v-row>
								<v-col>Name</v-col>
								<v-col>Points</v-col>
								<v-col>Max Purchases</v-col>
								<v-col>Action</v-col>
							</v-row>
							<v-divider class="mb-6 mt-4 opacity-80"></v-divider>
							<draggable
									class="list-group"
									tag="ul"
									v-model="selectedPrizes"
									@start="drag = true"
									@end="onDragEnd"
							>
								<transition-group type="transition" :name="!drag ? 'flip-list' : null">
									<v-row
											v-for="(prize, index) in selectedPrizes"
											:key="prize.id"
									>
										<v-col>
											<v-text-field
													v-model="prize.name"
													class="rounded-lg"
													label="Prize Name"
													outlined
													persistent-hint
													type="text"
													readonly
											></v-text-field>
										</v-col>
										<v-col>
											<v-text-field
													v-model.number="prize.amount"
													class="rounded-lg required"
													label="Points"
													outlined
													persistent-hint
													:rules="rules.prize_points"
													type="number"
													@wheel.native.prevent
											></v-text-field>
										</v-col>
										<v-col>
											<v-text-field
													v-model.number="prize.max_purchases"
													class="rounded-lg required"
													label="Max Purchases"
													outlined
													persistent-hint
													:rules="rules.prize_max_purchases"
													type="number"
													@wheel.native.prevent
											></v-text-field>
										</v-col>
										<v-col>
											<v-btn
													class="mb-6 ms-2 mt-2 rounded-lg"
													color="error"
													depressed
													@click="removePrizeFromSelectedPrizes(index)"
											>
												Remove
											</v-btn>
										</v-col>
									</v-row>
								</transition-group>
							</draggable>
						</ui-box>

					</v-col>
				</v-row>

			</ui-box>

			<ui-box
					v-if="shouldShowSection('prize_setup') && !(shouldShowSection('basic') || shouldShowSection('advanced'))">
				<h5>Award Points on Redemption Rule</h5>
				<span class="grey--text text--darken-1 text-body-2">
				</span>

				<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

				<v-row>
					<v-col>
						<v-text-field
								v-model.number="newPass.rules[0].settings.default_checkin_points"
								class="rounded-lg"
								label="All check-ins assigned points"
								outlined
								persistent-hint
								type="number"
								@wheel.native.prevent
						></v-text-field>
					</v-col>
					<v-col>
						<v-text-field
								v-model.number="newPass.rules[0].settings.default_standard_points"
								class="rounded-lg"
								label="All standard redemptions assigned points"
								outlined
								persistent-hint
								type="number"
								@wheel.native.prevent
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-select
								v-model="endType"
								class="rounded-lg"
								:items="[{name: 'Days after end', value: 'duration'}, {name: 'Specific Date', value: 'date'}]"
								item-text="name"
								label="Points redemption end date"
								outlined
						></v-select>
					</v-col>
					<v-col v-if="endType === 'duration'">
						<v-text-field
								v-model.number="newPass.rules[0].settings.usable_until_days"
								class="rounded-lg"
								label="Number of days until points are usable after pass ends"
								outlined
								persistent-hint
								type="number"
								@wheel.native.prevent
						></v-text-field>
					</v-col>
					<v-col v-if="endType === 'date'">
						<bw-date-time-picker
								v-model="newPass.rules[0].settings.end_date_time"
								label="Points Valid Until"
						></bw-date-time-picker>
					</v-col>
				</v-row>

				<v-divider class="mb-6 mt-4 opacity-80"></v-divider>
				<v-row>
					<v-col>
						<h6>Points on Products</h6>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-select
								v-model="filterCategories"
								class="rounded-lg"
								:items="allCategories"
								item-text="name"
								item-value="category_id"
								label="Filter by Venue Category"
								multiple
								chips
								outlined
						></v-select>
					</v-col>
					<v-col>
						<v-select
								v-model="filterProductTypes"
								class="rounded-lg"
								:items="allProductTypes"
								item-text="name"
								label="Filter by Product Type"
								multiple
								chips
								outlined
						></v-select>
					</v-col>
					<v-col>
						<v-select
								v-model="filterRedemptionValidation"
								class="rounded-lg"
								:items="[{name: 'None', value: ''}, {name: 'Pin', value: 'pin'}, {name: 'GPS', value: 'gps'}, {name: 'GPS or Pin', value: 'gpsOrPin'}, {name: 'QR Code Scan', value: 'qr'}]"
								item-text="name"
								label="Filter by Redemption Validation"
								multiple
								chips
								outlined
						></v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-row
								v-for="(productWithPoints, index) in this.passProductsWithPointsFiltered"
								:key="productWithPoints.product.id"
						>
							<v-col>
								<v-text-field
										v-model="productWithPoints.product.name"
										class="rounded-lg"
										label="Product Name"
										outlined
										persistent-hint
										type="text"
										readonly
								></v-text-field>
							</v-col>
							<v-col>
								<v-text-field
										v-model.number="productWithPoints.points"
										class="rounded-lg"
										label="Points"
										outlined
										persistent-hint
										type="number"
										@change="updateProductPoints(productWithPoints)"
										@wheel.native.prevent
								></v-text-field>
							</v-col>
						</v-row>
					</v-col>
				</v-row>

			</ui-box>
		</v-col>
	</v-row>
</template>

<script>
import draggable from 'vuedraggable';

export default {
	name: "PrizeSetup",
	components: {
		draggable
	},
	props: {
		newPass: {
			type: Object,
			required: true,
		},
		partner: {
			type: Object | null,
			default: null
		},
		extraData: {
			type: Object,
			default: () => ({})
		},
		showSections: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			drag: false,
			allPrizes: [],
			allPrizesSelection: [],
			passProductsWithPoints: [],
			filterCategories: [],
			filterProductTypes: [],
			filterRedemptionValidation: [],
			rules: {
				prize_points: [
					v => !!v || 'Prize points are required',
					v => (v && v > 0) || 'Prize points must be greater than 0',
				],
				prize_max_purchases: [
					v => !!v || 'Max purchases are required',
				],
			}
		}
	},
	mounted() {
		this.setupPassProductsWithPoints();
		this.refreshAllPrizes();
		if(!this.newPass.prizes) {
			this.$set(this.newPass, 'prizes', []);
		}
	},
	computed: {
		selectedPrizes: {
			get() {
				return this.newPass.prizes;
			},
			set(value) {
				this.newPass.prizes = value;
			}
		},
		endType: {
			get() {
				return this.newPass.rules[0].settings.end_type ?? 'duration';
			},
			set(value) {
				if(value === 'duration') {
					this.$set(this.newPass.rules[0].settings, 'end_date_time', null);
				}
				else {
					this.$set(this.newPass.rules[0].settings, 'usable_until_days', null);
				}
				this.$set(this.newPass.rules[0].settings, 'end_type', value);
			}
		},
		allPrizesNotSelected() {
			return this.allPrizes.filter(prize => !this.newPass.prizes.some(selectedPrize => selectedPrize.id === prize.id));
		},
		passProductsWithPointsFiltered() {
			return this.passProductsWithPoints.filter(this.productMatches);
		},
		allProductsById() {
			return this.keyById(this.extraData.passProducts);
		},
		allCategories() {
			return Object.values(this.extraData.venueCategories);
		},
		allProductTypes() {
			let types = {};
			this.extraData.passProducts.forEach(product => {
				const productTypeCode = product?.product_type_code;
				if(productTypeCode) {
					types[productTypeCode] = {
						'value': productTypeCode,
						'name': productTypeCode,
					};
				}
			});
			types = Object.values(types);
			types.push({
				'value': null,
				'name': 'Not Set',
			});
			return types;
		},
	},
	methods: {
		shouldShowSection(section) {
			return !this.showSections.length || this.showSections.includes(section);
		},
		addPrizeToSelectedPrizes() {
			//compute the max sort_order for all the this.newPass.prizes
			let maxSortOrder = 0;
			this.newPass.prizes.forEach(prize => {
				if(prize.sort_order > maxSortOrder) {
					maxSortOrder = prize.sort_order;
				}
			});
			this.allPrizesSelection.forEach(prizeId => {
				this.allPrizes.find((item) => {
					if(item.id === prizeId) {
						item.product_id = prizeId;
						item.amount = 0;
						item.max_purchases = 0;
						item.sort_order = ++maxSortOrder;
						this.newPass.prizes.push(item);
						return true;
					}
				});
			});
			this.allPrizesSelection = [];
		},
		removePrizeFromSelectedPrizes(index) {
			this.newPass.prizes.splice(index, 1);
			this.sortSelectedPrizes();
		},
		sortSelectedPrizes() {
			let sortOrder = 1;
			this.newPass.prizes.forEach(prize => {
				prize.sort_order = sortOrder++;
			});
		},
		onDragEnd() {
			this.drag = false;
			this.sortSelectedPrizes();
		},
		setupPassProductsWithPoints() {
			if(this.extraData.passProducts && this.extraData.passProducts.length) {
				this.extraData.passProducts.forEach(product => {
					let points = null;
					if(this.newPass.rules[0]?.settings?.dealProducts) {
						for (const productId in this.newPass.rules[0].settings.dealProducts) {
							if(parseInt(productId) === product.id) {
								points = this.newPass.rules[0].settings.dealProducts[productId];
								break;
							}
						}
					}
					const passProductWithPoints = new PassProductWithPoints(product, points);
					this.passProductsWithPoints.push(passProductWithPoints);
				});
			}
		},
		updateProductPoints(productWithPoints) {
			if(!this.newPass.rules[0].settings.dealProducts) {
				this.$set(this.newPass.rules[0].settings, 'dealProducts', {});
			}
			if(productWithPoints.points) {
				this.newPass.rules[0].settings.dealProducts[productWithPoints.product.id] = parseInt(productWithPoints.points);
			}
			else {
				delete this.newPass.rules[0].settings.dealProducts[productWithPoints.product.id];
			}
		},
		refreshAllPrizes() {
			axios.get(`/partner-portal/${this.partner.id}/passes/prizes`)
					.then(response => {
						this.allPrizes = response.data.allPrizes;
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					});
		},
		keyById(items) {
			const result = {};
			items.forEach(item => result[item.id] = item);
			return result;
		},
		productMatches(productWithPoints) {
			const plainProduct = this.allProductsById[productWithPoints.product.id];
			return this.productMatchesCategories(plainProduct) && this.productMatchesTypes(plainProduct) && this.productMatchesRedemptionValidation(plainProduct);
		},
		productMatchesCategories(product) {
			return this.filterCategories.length === 0 ||
					product.r_venue?.r_categories?.some(category =>
							this.filterCategories.some(filterCat => category.category_id === filterCat)
					);
		},
		productMatchesTypes(product) {
			return this.filterProductTypes.length === 0
					|| this.filterProductTypes.some(filterType => product.product_type_code === filterType);
		},
		productMatchesRedemptionValidation(product) {
			return this.filterRedemptionValidation.length === 0
					|| this.filterRedemptionValidation.some(filterRV => product.redemption_validation === filterRV);
		},

	}
}

function PassProductWithPoints(product, points) {
	this.product = product;
	this.points = points;
}

</script>

